import { render, staticRenderFns } from "./UserDocumentsDelete.vue?vue&type=template&id=1c6262fb"
import script from "./UserDocumentsDelete.vue?vue&type=script&lang=js"
export * from "./UserDocumentsDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports